import { IconProps } from 'src/utils/icon';

const MailIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 36 36"
  >
    <path
      fill={fill}
      d="M24.562 4.156c-1.446-1.152-3.873-3.59-6.41-3.59-2.52 0-4.909 2.388-6.41 3.59a1178.29 1178.29 0 00-9.968 8.038 3.296 3.296 0 00-1.208 2.551V32.44a3.297 3.297 0 003.297 3.297H32.44a3.297 3.297 0 003.297-3.297V14.745a3.295 3.295 0 00-1.209-2.551c-2.443-2-7.59-6.152-9.966-8.038zm7.878 29.383H3.863a1.1 1.1 0 01-1.099-1.1V14.729c0-.33.148-.643.404-.851 1.805-1.474 8.365-6.75 9.94-8 1.211-.965 3.416-3.113 5.043-3.113 1.627 0 3.833 2.148 5.043 3.113 1.575 1.25 8.136 6.527 9.941 8a1.097 1.097 0 01.404.852v17.71a1.1 1.1 0 01-1.1 1.1zm-.602-14.86a.824.824 0 01-.122 1.162 1185.999 1185.999 0 01-7.155 5.711c-1.445 1.154-3.906 3.608-6.41 3.59-2.513.018-5.003-2.466-6.41-3.59a1182.568 1182.568 0 01-7.155-5.711.824.824 0 01-.122-1.162l.347-.426a.824.824 0 011.157-.122c1.564 1.262 3.78 3.032 7.14 5.7 1.158.923 3.449 3.139 5.043 3.113 1.595.025 3.886-2.19 5.043-3.113 3.361-2.668 5.577-4.438 7.14-5.7a.824.824 0 011.157.122l.347.426z"
    />
  </svg>
);

export default MailIcon;
